import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheck } from 'react-icons/fi';

// Sample names and professions for realistic notifications - DOCTORS
const registrationData = [
  { name: "Dr. Rajesh Kumar", profession: "General Physician" },
  { name: "Dr. Priya Sharma", profession: "Pediatrician" },
  { name: "Dr. Arun Karthik", profession: "Dermatologist" },
  { name: "Dr. Meera Iyer", profession: "Gynecologist" },
  { name: "Dr. Vikram Reddy", profession: "Orthopedic Surgeon" },
  { name: "Dr. Kavita Menon", profession: "Psychiatrist" },
  { name: "Dr. Suresh Babu", profession: "Cardiologist" },
  { name: "Dr. Anjali Reddy", profession: "Dentist" },
  { name: "Dr. Vijay Anand", profession: "Neurologist" },
  { name: "Dr. Lakshmi Devi", profession: "ENT Specialist" },
  { name: "Dr. Karthik Raja", profession: "Ophthalmologist" },
  { name: "Dr. Sanjay Patel", profession: "General Physician" },
  { name: "Dr. Deepa Krishnan", profession: "Pediatrician" },
  { name: "Dr. Ramesh Kumar", profession: "Orthopedic Surgeon" },
  { name: "Dr. Sneha Reddy", profession: "Dermatologist" },
  { name: "Dr. Ganesh Moorthy", profession: "Cardiologist" },
  { name: "Dr. Anitha Iyer", profession: "Gynecologist" },
  { name: "Dr. Arjun Singh", profession: "Psychiatrist" },
  { name: "Dr. Divya Menon", profession: "Dentist" },
  { name: "Dr. Lakshmi Iyer", profession: "General Physician" }
];

/**
 * Recent Registrations Notification Component
 * Shows random registration notifications every 5 seconds
 * Positioned at top right corner (desktop) and top center (mobile)
 * Appears after 10 seconds delay
 */
export default function RecentRegistrations() {
  const [currentRegistration, setCurrentRegistration] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Function to show a random registration
    const showRandomRegistration = () => {
      // Pick a random registration from the list
      const randomIndex = Math.floor(Math.random() * registrationData.length);
      const registration = registrationData[randomIndex];
      
      setCurrentRegistration(registration);
      setIsVisible(true);

      // Hide after 4 seconds (will show new one after 5 seconds total)
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };

    // Show first notification after 10 seconds
    const initialTimeout = setTimeout(() => {
      showRandomRegistration();
    }, 10000);

    // Show new notification every 5 seconds (after initial delay)
    const interval = setInterval(() => {
      showRandomRegistration();
    }, 9000); // 4s show + 5s gap

    // Cleanup
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && currentRegistration && (
        <motion.div
          className="recent-registration-notification"
          initial={{ opacity: 0, x: 100, y: 0 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: 100, y: 0 }}
          transition={{ type: "spring", stiffness: 200, damping: 20 }}
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            background: '#1e3a5f',
            color: '#fff',
            padding: '12px 20px',
            borderRadius: '12px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.3)',
            border: '1px solid #14b8a6',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            maxWidth: '350px',
            width: 'calc(100% - 40px)'
          }}
        >
          <div 
            className="notification-icon"
            style={{
              background: 'rgba(20, 184, 166, 0.2)',
              borderRadius: '50%',
              padding: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#14b8a6'
            }}
          >
            <FiCheck size={20} />
          </div>
          <div className="notification-content">
            <div className="notification-name" style={{ fontWeight: 'bold', fontSize: '0.95rem' }}>
              {currentRegistration.name}
            </div>
            <div className="notification-text" style={{ fontSize: '0.85rem', color: '#cbd5e1' }}>
              <span className="profession" style={{ color: '#14b8a6', fontWeight: '500' }}>
                {currentRegistration.profession}
              </span> registered just now
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}